import { Box } from "@mantine/core";
import { ZoneSymbolKind } from "@utils/TestUtils";
import ZoneSymbolShapes, { ZONE_SYMBOL_VIEWBOX_SIZE } from "./ZoneSymbolShapes";

export interface ZoneSymbolProps {
  kind: ZoneSymbolKind;
}

export default function ZoneSymbol({ kind }: ZoneSymbolProps) {
  return (
    <Box style={{ width: "100%", height: "100%" }}>
      <svg
        viewBox={`0 0 ${ZONE_SYMBOL_VIEWBOX_SIZE} ${ZONE_SYMBOL_VIEWBOX_SIZE}`}
        width="100%"
        height="100%"
      >
        <ZoneSymbolShapes kind={kind} />
      </svg>
    </Box>
  );
}
